import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

import { auth } from "./modules/auth";
import { offers } from "./modules/offers";
import { availability } from "./modules/availability";
import { merchants } from "./modules/merchants";
import { outlets } from "./modules/outlets";
import { tribes } from "./modules/tribes";
import { tiles } from "./modules/tiles";
import { ui } from "./modules/ui.js";
import { cropper } from "./modules/cropper";
import { search } from "./modules/search";

Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    auth,
    offers,
    availability,
    merchants,
    outlets,
    tribes,
    tiles,
    ui,
    cropper,
    search
  },

  plugins: [createPersistedState()]
});
